<template>
    <div>
        <form-response-errors ref="formResponseErrors" :reload="reload"></form-response-errors>

        <div class="row" v-if="driver.id">
            <div class="col-lg-6 col-xl-4">

                <div class="card card-primary card-outline" :class="{'card-danger': driver.deleted_at }">
                    <div class="card-body box-profile">
                        <div class="text-center">
                            <i v-if="driver.deleted_at" class="fas fa-trash-alt fa-2x text-danger"></i>
                            <i v-else class="icon-driver fa-2x"></i>
                        </div>

                        <h3 class="profile-username text-center">{{ fio(driver) }}</h3>

                        <p class="text-muted text-center" v-if="driver.company">
                            <CompanyLink :company="driver.company" :ico="true"></CompanyLink>
                        </p>

                        <ul class="list-group list-group-unbordered mt-3 mb-3">
                            <li class="list-group-item">
                                <b>{{ trans("driver.Passport series") }}</b>
                                <span class="float-right">{{ driver.passport_seria }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("driver.Passport number") }}</b>
                                <span class="float-right">{{ driver.passport_number }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("driver.Passport issue date") }}</b>
                                <span class="float-right">{{ momentDateYYYY(driver.passport_date) }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("driver.Passport issue agency") }}</b>
                                <span class="float-right">{{ driver.passport_agency }}</span>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("driver.Phone") }}</b>
                                <a v-if="driver.phone" class="float-right"
                                   :href="'tel:' + driver.phone">{{ driver.phone }}
                                </a>
                            </li>
                            <li class="list-group-item">
                                <b>{{ trans("driver.Is blocked") }}</b>
                                <span class="float-right">
                                    <i v-if="driver.is_blocked" class="fas fa-check"></i>
                                    <span v-else>{{ trans("no") }}</span>
                                </span>
                            </li>
                        </ul>

                        <router-link v-if="can('update-driver')"
                                     :to="{name: 'driver-edit', params: {id: driver.id}}"
                                     class="btn btn-sm btn-primary mr-1">
                            <i class="fas fa-pencil-alt"></i>
                        </router-link>

                        <template v-if="can('create-driver')">
                            <router-link :to="{ name: 'driver-clone', params: { id: driver.id } }"
                                         class="btn btn-sm btn-primary mr-1">
                                <i class="fas fa-clone"></i>
                            </router-link>
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DriverService from "../../services/DriverService";
import User from "../../models/User";

export default {
    props: ['id'],
    data() {
        return {
            driver: {}
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        reload() {
            this.getData();
        },
        async getData() {
            try {
                this.$refs.formResponseErrors.hide();
                let response = await DriverService.getDetail(this.id, this.can('deleted-driver-read'));
                this.driver = response.data.data;
                this.$store.dispatch("breadcrumbs/setTitle", this.fio(this.driver));
            } catch (error) {
                this.$refs.formResponseErrors.show(error);
            }
        },
        fio(driver) {
            return User.fio(driver)
        }
    }
}
</script>
